import { createContext, type PropsWithChildren, useContext, useEffect, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useInboxLayerContext } from 'pages/settings/pages/inboxes/context/inboxLayerContext'
import { AddNumberFromAppStore } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AddNumberFromApp/store/addNumberFromAppStore'

const AddNumberFromAppContext = createContext<AddNumberFromAppStore | null>(null)

export const useAddNumberFromAppContext = () => {
  const context = useContext(AddNumberFromAppContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with AddNumberFromAppContext')

  return context
}

export const AddNumberFromAppProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const inboxLayerStore = useInboxLayerContext()
  const store = useMemo(
    () => new AddNumberFromAppStore(inboxLayerStore, entities),
    [inboxLayerStore, entities]
  )

  useEffect(() => {
    store.init()

    return () => {
      store.dispose()
    }
  }, [store])

  return (
    <AddNumberFromAppContext.Provider value={store}>{children}</AddNumberFromAppContext.Provider>
  )
}
